module.exports = __webpack_public_path__ + "media/images/emoticons/diamond-177ba76cca4bd8f911510c733d5a5c0a.gif";